<template lang="pug">
  .mt-6
    label.mb-6 {{ $t('details.address_sort_dragndrop') }}
    draggable(animation="200"  v-model="list" @change="onDragEnd")
      .row.w-100.p-4(v-for="item in list")
          address-row(:address="getAddress(item.id)")
</template>
<script>
import Draggable from 'vuedraggable'
import AddressRow from '@/components/organism/location/SortLocation/AddressRow.vue'

export default {
    components: {
        AddressRow,
        Draggable,
    },
    props: {
        addresses: {
            type: Array,
        },
    },
    data() {
        return {
            list: [],
        }
    },
    mounted() {
        this.list = this.addresses.map((x, index) => {
            return {
                id: x.id,
                position: parseInt(index),
            }
        })
    },
    methods: {
        getAddress(id) {
            return this.addresses.find((x) => x.id === id)
        },
        onDragEnd() {
            for (let i in this.list) {
                this.list[i].position = parseInt(i)
            }
        },
        async save() {
            await this.$user.setAddressPositions(this.list)
        },
    },
}
</script>
